/* eslint-disable */
import React, { useEffect, useState, useMemo } from "react";
import { Link } from "react-router-dom";

import { useTranslation } from "react-i18next";

// Material UI table
import { MaterialReactTable } from "material-react-table";
//Material UI components for rendring menu and others
import { Box, MenuItem } from "@mui/material";

/*import url and gateway methods */
import { getData, postData, putData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

import AddLabelModal from "components/Common/Modal/AddLabelModal";
import AccessDeniedView from "components/Common/AccessDeniedView/AccessDeniedView";
import TreatmentFilterPopup from "./Popup/TreatmentFilterPopup";

import TabsHeader from "components/Common/TabsHeader/TabsHeader";

//import common header objects
import { commonHeaderLinkLists } from "helper/ClinicalManagementHelper/ClinicalManagementHelper";
import AlertNotification from "components/Common/AlertNotification/AlertNotification";
import { createContactChatHandler } from "helper/AppUserHelper/AppUserHelper";
import { replaceListByIds, updateListByIds } from "helper/Common/CommonHelper";
import { removeTagHandler } from "helper/TagHelper/TagHelper";
import TreatmentListHeader from "./Header/TreatmentListHeader";
import SaveTreatment from "./Popup/SaveTreatment";
import ViewTreatment from "./Popup/ViewTreatment";

// Add treatment status options and helper function
const treatmentStatusOptions = [
  { label: "Planned", value: "planned" },
  { label: "Ongoing", value: "ongoing" },
  { label: "Completed", value: "completed" },
  { label: "Paused", value: "paused" },
  { label: "Cancelled", value: "cancelled" },
];

// Helper function to map single value to option object
const mapValuesToSingleOption = (savedValue, optionsList) => {
  if (!savedValue) return null;

  const foundOption = optionsList.find((option) => option.value === savedValue);
  return foundOption || { value: savedValue, label: savedValue }; // fallback if not found in options
};

const TreatmentsListBody = () => {
  /* ------------- Language translation imports starts here ------------- */
  const { t, i18n } = useTranslation();

  const moduleAccess = localStorage.getItem("moduleaccess");
  const token = localStorage.getItem("token");
  const userInfo = JSON.parse(localStorage.getItem("userInfo"));

  const [tagList, setTagList] = useState([]);
  const [treatmentList, setTreatmentList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [rowSelection, setRowSelection] = useState({});
  const [selectedTreatmentIds, setSelectedTreatmentIds] = useState([]);
  const [selectedTreatmentId, setSelectedTreatmentId] = useState(null);
  const [selectedViewTreatmentId, setSelectedViewTreatmentId] = useState(null);
  const [selectedTagId, setSelectedTagId] = useState(null);
  const [selectedTreatmentIdForTag, setSelectedTreatmentIdForTag] =
    useState(null);

  const [filterDates, setfilterDates] = useState("");
  const [filterName, setfilterName] = useState("");
  const [filterSlug, setfilterSlug] = useState("");
  const [filterSubject, setfilterSubject] = useState("");
  const [filterLabels, setfilterLabels] = useState([]);

  const [isReload, setIsReload] = useState(false);
  const [isFilterReset, setIsFilterReset] = useState(false);

  // json filter query
  const [jsonFilterQuery, setJsonFilterQuery] = useState([]);

  const [showAlert, setShowAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const getAllTreatments = async () => {
    setRowSelection({});
    setSelectedTreatmentIds([]);
    setIsLoading(true);

    try {
      let requestUrl =
        url.API_BASE_URL +
        url.API_GET_ALL_TREATMENTS +
        `?token=${token}&modulename=treatment`;

      if (jsonFilterQuery.length > 0) {
        // Sanitize the jsonFilterQuery
        const sanitizedQuery = jsonFilterQuery.map((filter) => {
          if (
            (filter.operator === "includes" ||
              filter.operator === "excludes") &&
            Array.isArray(filter.value)
          ) {
            return {
              ...filter,
              value: filter.value.map((item) => item.value).join(","), // Extract and join values as a comma-separated string
            };
          }
          return filter;
        });

        requestUrl = requestUrl + `&filters=${JSON.stringify(sanitizedQuery)}`;
      }

      console.log("Treatment Request URL:", requestUrl); // Debugging line to check the final request URL

      const response = await getData(requestUrl);

      console.log("Treatment Response Data:", response); // Debugging line to check the response data

      setIsLoading(false);

      if (response.status) {
        setTreatmentList(response.data);

        setShowAlert(true);
        setAlertMessage("Treatments fetched successfully");
        setMessageType("success");
      }
    } catch (error) {
      setAlertMessage(error.message);
      setMessageType("error");
    }

    setShowAlert(true);
  };

  //function for change status
  const changeStatusHandler = async () => {};

  //function for reset filter
  const resetFilterData = () => {
    setIsFilterReset(true);
    setJsonFilterQuery([]);
    setIsReload(true);
  };

  useEffect(() => {
    if (isReload) {
      getAllTreatments();
      setIsReload(false);
    }
  }, [isReload]);

  useEffect(() => {
    if (jsonFilterQuery.length > 0) {
      getAllTreatments();
    }
  }, [jsonFilterQuery]);

  useEffect(() => {
    getAllTreatments();
  }, []);

  /*
   * Material React Table Column and States
   */
  const columns = useMemo(
    () => [
      {
        accessorKey: "#",
        header: t("Actions"),
        Cell: ({ row }) => (
          <button
            className="action_btn_mui"
            data-bs-toggle="offcanvas"
            data-bs-target="#saveTreatmentTemplateOffCanvas"
            aria-controls="saveTreatmentTemplateOffCanvas"
            onClick={() => {
              setSelectedTreatmentId(row.original._id);
            }}
          >
            <span className="d-block material-symbols-outlined horz_icon">
              more_horiz
            </span>
          </button>
        ),
        enableColumnActions: false, // Hides the column action icon
        enableColumnDragging: false, // Hides the move icon
        enableSorting: false,
      },
      {
        accessorKey: "title",
        header: t("Treatment Name"),
        Cell: ({ row }) => (
          <span
            className="text-primary fw-semibold cursor-pointer"
            style={{ cursor: "pointer" }}
            data-bs-toggle="offcanvas"
            data-bs-target="#viewTreatmentOffCanvas"
            aria-controls="viewTreatmentOffCanvas"
            onClick={() => {
              setSelectedViewTreatmentId(row.original._id);
            }}
          >
            {row.original.title}
          </span>
        ),
      },
      {
        accessorKey: "tags",
        header: t("Labels"),
        size: 300,
        Cell: ({ row }) => (
          <div className="label-wrapper py-1">
            <div className="d-flex gap-2">
              <div
                className={
                  row.original.tags && row.original.tags.length > 0
                    ? "label-container flex-grow-1"
                    : "d-none"
                }
              >
                <ul
                  className="d-flex flex-wrap gap-2 m-0 p-0"
                  style={{ listStyle: "none" }}
                >
                  {row.original.tags &&
                    row.original.tags.map((tag, index) => (
                      <li key={index} className="d-inline-flex">
                        <div className="badge d-flex align-items-center px-3 py-2 border-0 gradient-light text-black rounded-pill">
                          <span className="badge-text fs-xs fw-medium me-1">
                            {tag.title}
                          </span>
                          <Link
                            to="#"
                            // className={`${
                            //   tag.moderator &&
                            //   (tag.moderator.toString() === userInfo._id.toString() ||
                            //   userInfo.role.slug === "ADMIN" ||
                            //   userInfo.role.slug === "SUPER_ADMIN")
                            //     ? "d-block"
                            //     : "d-none"
                            // }`}
                            onClick={() => {
                              setSelectedTreatmentIdForTag(row.original._id);
                              setSelectedTagId(tag._id);
                              removeTagFromTreatment(
                                [tag._id],
                                row.original._id
                              );
                            }}
                          >
                            {selectedTagId &&
                            selectedTagId === tag._id &&
                            selectedTreatmentIdForTag &&
                            selectedTreatmentIdForTag === row.original._id ? (
                              <div
                                className="spinner-border spinner-border-sm text-primary ms-1"
                                role="status"
                                style={{ height: "12px", width: "12px" }}
                              >
                                <span className="visually-hidden">
                                  Loading...
                                </span>
                              </div>
                            ) : (
                              <span
                                className="d-block text-primary material-symbols-outlined icon-sm ms-1"
                                style={{ cursor: "pointer" }}
                              >
                                cancel
                              </span>
                            )}
                          </Link>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
              <button
                className="btn btn-light btn-sm rounded-circle p-1 shadow-sm border-0 d-flex align-items-center justify-content-center mt-1"
                style={{ width: "24px", height: "24px" }}
                data-bs-toggle="modal"
                data-bs-target="#addLabelModal"
                onClick={() => setSelectedTreatmentIds([row.original._id])}
              >
                <span
                  className="material-symbols-outlined text-primary"
                  style={{ fontSize: "16px" }}
                >
                  add
                </span>
              </button>
            </div>
          </div>
        ),
      },
      {
        accessorKey: "projecttypeid.name",
        header: t("Speciality"),
      },
      {
        accessorKey: "medicalextension.treatmentstatus",
        header: t("Treatment Status"),
        Cell: ({ row }) => {
          const treatmentStatus =
            row.original.medicalextension?.treatmentstatus;
          if (treatmentStatus) {
            const mappedStatus = mapValuesToSingleOption(
              treatmentStatus,
              treatmentStatusOptions
            );
            const statusColor =
              mappedStatus?.value === "completed"
                ? "bg-success"
                : mappedStatus?.value === "ongoing"
                ? "bg-primary"
                : mappedStatus?.value === "planned"
                ? "bg-info"
                : mappedStatus?.value === "paused"
                ? "bg-warning"
                : mappedStatus?.value === "cancelled"
                ? "bg-danger"
                : "bg-secondary";

            return (
              <span className={`badge px-2 py-1 fs-7 ${statusColor}`}>
                {mappedStatus?.label || "UNKNOWN"}
              </span>
            );
          }
          return (
            <span className="badge px-2 py-1 fs-7 bg-secondary">NOT SET</span>
          );
        },
      },
      {
        accessorKey: "medicalextension.doctor",
        header: t("Doctor"),
        Cell: ({ row }) => {
          return (
            <Box>
              {row.original.medicalextension &&
              row.original.medicalextension.doctor
                ? row.original.medicalextension.doctor.name
                : "-"}
            </Box>
          );
        },
      },
      {
        accessorKey: "medicalextension.patient",
        header: t("Patient"),
        Cell: ({ row }) => {
          return (
            <Box>
              {row.original.medicalextension &&
              row.original.medicalextension.patient
                ? row.original.medicalextension.patient.name
                : "-"}
            </Box>
          );
        },
      },
      {
        accessorKey: "startdate",
        header: t("Start Date"),
        Cell: ({ row }) => {
          return (
            <Box>
              {row.original.startdate
                ? new Date(row.original.startdate).toLocaleDateString("en-GB")
                : "-"}
            </Box>
          );
        },
      },
      {
        accessorKey: "enddate",
        header: t("End Date"),
        Cell: ({ row }) => {
          return (
            <Box>
              {row.original.enddate
                ? new Date(row.original.enddate).toLocaleDateString("en-GB")
                : "-"}
            </Box>
          );
        },
      },
    ],
    [
      i18n.language,
      selectedTagId,
      selectedTreatmentIdForTag,
      userInfo._id,
      userInfo.role.slug,
    ]
  );

  useEffect(() => {
    //do something when the row selection changes...
    const selectedIdsArray = Object.keys(rowSelection).filter(
      (key) => rowSelection[key]
    );
    if (selectedIdsArray.length > 0) {
      setSelectedTreatmentIds(selectedIdsArray);
    } else {
      setSelectedTreatmentIds([]);
    }
  }, [rowSelection]);

  //initialize the column order
  const initialColumnOrder = [
    "#",
    "mrt-row-select",
    ...columns.map((c) => c.accessorKey),
  ]; //array of column ids (Initializing is optional as of v2.10.0)

  /* Closes the alert by updating the state variables.*/
  const onAlertClose = () => {
    setShowAlert(false);
    setAlertMessage("");
    setMessageType("");
  };

  const removeTagFromTreatment = async (tagIds, componentId) => {
    try {
      const componentUrl = url.API_ADD_REMOVE_TAG_PROJECT;
      const data = await removeTagHandler(tagIds, componentId, componentUrl);

      if (data) {
        afterTagModalActionClose(data);
      }
    } catch (error) {
      console.log(error.message);
      setAlertMessage(error.message);
      setMessageType("error");
      setShowAlert(true);
    } finally {
      setTimeout(() => {
        setSelectedTagId(null);
        setSelectedTreatmentIdForTag(null);
      }, 1000);
    }
  };

  const afterTagModalActionClose = (data = []) => {
    setTimeout(() => {
      setTreatmentList((prev) => replaceListByIds(prev, data));
    }, 1000);
  };

  if (
    userInfo.role.slug === "ADMIN" ||
    userInfo.role.slug === "SUPER_ADMIN" ||
    (moduleAccess.includes("MOD_CRM") && moduleAccess.includes("MOD_LEAD"))
  ) {
    return (
      <div id="content_wrapper">
        <section className="crm-wrapper bg-white pb-5">
          <TabsHeader
            commonHeaderObject={commonHeaderLinkLists(t)}
            activeOption={t("Treatment")}
          />
          <div className="container-fluid px-lg-5">
            <TreatmentListHeader
              reloadTreatments={resetFilterData}
              changeStatusHandler={changeStatusHandler}
            />
            {isLoading ? (
              <div className="placeholder-glow d-flex flex-column gap-4">
                <span className="placeholder placeholder-lg bg-secondary col-12"></span>
                <span className="placeholder placeholder-lg bg-secondary col-8"></span>
                <span className="placeholder placeholder-lg bg-secondary col-4"></span>
              </div>
            ) : (
              <div className="table-wrapper">
                <MaterialReactTable
                  columns={columns} // map columns to be displayed with api data,
                  data={treatmentList} // data from api to be displayed
                  enableGrouping // to enable grouping of column
                  enableRowSelection // enable showing checkbox
                  getRowId={(row) => row._id} // map which value to select with row checkbox
                  onRowSelectionChange={setRowSelection} //connect internal row selection state to your own
                  state={{ rowSelection, columnOrder: initialColumnOrder }} //pass our managed row selection state to the table to use
                  initialState={{
                    rowSelection,
                    columnOrder: initialColumnOrder,
                  }}
                  defaultColumn={{
                    minSize: 20,
                    maxSize: 300,
                    size: 50, //make columns wider by default
                  }}
                  muiTableContainerProps={{
                    sx: {
                      maxHeight: "60vh",
                    },
                  }}
                  enableStickyHeader
                />
              </div>
            )}
          </div>

          {/* ==== modals and popup section === */}
          {/* --- filter popup --- */}
          <TreatmentFilterPopup
            jsonFilterQuery={jsonFilterQuery}
            setJsonFilterQuery={setJsonFilterQuery}
            moduleSlug={"treatment"}
            isFilterReset={isFilterReset}
            setIsFilterReset={setIsFilterReset}
          />

          <AddLabelModal
            moduleName="treatment"
            selectedIds={selectedTreatmentIds}
            afterTagModalClose={() => {
              setTimeout(() => {
                getAllTreatments();
              }, 2200);
            }}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
            onModalClose={() => {
              setSelectedTreatmentIds([]);
              setRowSelection({});
            }}
          />

          <SaveTreatment
            selectedTreatmentId={selectedTreatmentId}
            setSelectedTreatmentId={setSelectedTreatmentId}
            afterActionClose={getAllTreatments}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          <ViewTreatment
            selectedTreatmentId={selectedViewTreatmentId}
            setSelectedTreatmentId={setSelectedViewTreatmentId}
            afterActionClose={getAllTreatments}
            setShowAlert={setShowAlert}
            setAlertMessage={setAlertMessage}
            setMessageType={setMessageType}
          />

          {showAlert && (
            <AlertNotification
              showAlert={showAlert}
              message={alertMessage}
              alertType={messageType}
              onClose={onAlertClose}
            />
          )}
        </section>
      </div>
    );
  } else {
    return <AccessDeniedView />;
  }
};

export default TreatmentsListBody;
